import React from 'react';
import {DragDropContext, Droppable, Draggable} from 'react-beautiful-dnd';
import Collapsible from 'react-collapsible';
import Border from "./Border";

export default class LayoutEditor extends React.Component {
  handleDragEnd = (result) => {
    const {source, destination} = result;
    if (!destination) {
      return;
    }

    const {layout, onChange} = this.props;
    const updatedLayout = [...layout];
    const movingItemIndex = updatedLayout.findIndex((item, idx) => {
      const group = layout.filter(i => i.position === source.droppableId);
      return item === group[source.index];
    });

    if (movingItemIndex === -1) {
      return;
    }

    const [movedItem] = updatedLayout.splice(movingItemIndex, 1);
    movedItem.position = destination.droppableId;

    const reordered = [];
    let insertIndex = 0;

    for (let i = 0; i < updatedLayout.length; i++) {
      const current = updatedLayout[i];
      if (current.position === destination.droppableId) {
        if (insertIndex === destination.index) {
          reordered.push(movedItem);
        }
        reordered.push(current);
        insertIndex++;
      } else {
        reordered.push(current);
      }
    }

    if (!reordered.includes(movedItem)) {
      reordered.push(movedItem);
    }

    onChange(reordered);
  };

  renderDroppable = (position, title, fullWidth = false) => {
    const blocks = this.props.layout.filter(b => b.position === position);
    const containerClass = fullWidth ? "col-12" : "col-md-6";

    return (
      <div className={containerClass}>
        <h5 className="mb-1 mt-1 text-center" style={{fontWeight: 600}}>{title}</h5>
        <Droppable droppableId={position}>
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              className="droppable-zone"
              style={{
                backgroundColor: snapshot.isDraggingOver ? "#e3f2fd" : "#f8f9fa",
                border: snapshot.isDraggingOver ? "2px dashed #2196f3" : "1px solid #dee2e6",
                borderRadius: "6px",
                padding: "10px",
                marginTop: "6px",
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              {blocks.map((block, index) => this.renderDraggable(block, index))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </div>
    );
  };

  renderDraggable = (block, index) => {
    return (
      <Draggable key={block.key} draggableId={block.key} index={index}>
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={{
              border: "1px solid #ccc",
              padding: "8px",
              background: snapshot.isDragging ? "#e0f7fa" : "#fff",
              borderRadius: "4px",
              fontSize: "14px",
              textAlign: "center",
              boxShadow: snapshot.isDragging ? "0 2px 8px rgba(0,0,0,0.15)" : "none",
              ...provided.draggableProps.style,
            }}
          >
            {block.label}
          </div>
        )}
      </Draggable>
    );
  };

  render() {
    const {defaultLayout, onReset} = this.props;
    return (
      <Border>
        <Collapsible trigger="Page Layout" className="mb-3">
          <DragDropContext onDragEnd={this.handleDragEnd}>
            <div className="row">
              {this.renderDroppable("left", "Left Column")}
              {this.renderDroppable("right", "Right Column")}
            </div>
            <div className="row mt-4">
              {this.renderDroppable("row", "Full Width Below", true)}
            </div>
          </DragDropContext>
          {defaultLayout && (
            <div className="d-flex justify-content-end mt-4">
              <a
                className="btn btn--primary type--uppercase"
                style={{
                  background: "#fa6160",
                  borderColor: "#fa6160"
                }}
                onClick={onReset}
              >
              <span className="material-icons btn__text mr-1"
                    style={{
                      fontSize: "18px",
                      lineHeight: "1",
                      position: "relative",
                      top: "5px"
                    }}>
                restart_alt
              </span>
                <span className="btn__text">
                  Use Default Layout
                </span>
              </a>
            </div>
          )}
        </Collapsible>
      </Border>
    );
  }
}